export type SoundKind='click'|'wager'|'win'|'loss'|'achievement';
export function playSound(kind:SoundKind,enabled:boolean){
  if(!enabled||typeof AudioContext==='undefined')return;
  const ctx=new AudioContext(),osc=ctx.createOscillator(),gain=ctx.createGain();
  const tones:Record<SoundKind,[number,number]>={click:[240,.025],wager:[360,.08],win:[660,.22],loss:[150,.18],achievement:[880,.3]};
  const[freq,duration]=tones[kind];osc.type=kind==='loss'?'sawtooth':'sine';osc.frequency.setValueAtTime(freq,ctx.currentTime);
  if(kind==='win'||kind==='achievement')osc.frequency.exponentialRampToValueAtTime(freq*1.5,ctx.currentTime+duration);
  gain.gain.setValueAtTime(.045,ctx.currentTime);gain.gain.exponentialRampToValueAtTime(.001,ctx.currentTime+duration);
  osc.connect(gain).connect(ctx.destination);osc.start();osc.stop(ctx.currentTime+duration);osc.onended=()=>ctx.close();
}
